module.exports = __webpack_public_path__ + "img/247.4ec35408.jpg";